export const CLEAR_USERS = 'CLEAR_USERS';
export const SET_USERS = 'SET_USERS';
